import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { duplicateDocument } from '../store/Supplier.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import { BombiixModal } from '../../../Components/BombiixModal';
import { NewInput } from '../../../Components/PIM/common/NewInput';
import { NewRadio } from '../../../Components/PIM/common/NewRadio';

function DuplicateDocument({ onOpen, toggle, data, refreshPage, duplicateDocumentData }) {
  const { t } = useTranslation('modules/partner-overview');
  const [documentName, setDocumentName] = useState('');
  const [showLoader, setshowLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [archiveOption, setArchiveOption] = useState('yes');

  const onSubmit = async () => {
    if (!documentName) {
      setErrors({ documentName: t('EDIT_SUPPORTING_DOCUMENT.REQUIRED_FIELDS') });
      return;
    }
    const submitedData = {
      documentName,
      isArchive: archiveOption === 'yes',
      docId: data._id,
      section: 'supplierOverview',
      action: 'addEdit',
    };
    setshowLoader(true);
    const res = await duplicateDocumentData(submitedData, t);
    setshowLoader(false);
    if (res?.code === 200) {
      toggle();
      refreshPage();
    }
  };

  return (
    <BombiixModal show={onOpen} title={t('PARTNER_OVERVIEW.DUPLICATE_TITLE')} onClose={toggle} onSave={onSubmit} saveDisabled={showLoader} size="md">
      {showLoader ? (
        <Loader />
      ) : (
        <>
          <div className="common-input-control">
            <NewInput
              name="documentName"
              label={t('PARTNER_OVERVIEW.DUPLICATE_TITLE')}
              placeholder={t('EDIT_SUPPORTING_DOCUMENT.ENTER_DOCUMENT_NAME')}
              value={documentName}
              invalid={Boolean(errors.documentName)}
              onChange={(e) => setDocumentName(e.target.value)}
            />
            {errors.documentName && <span className="error-message">{t('EDIT_SUPPORTING_DOCUMENT.REQUIRED_FIELDS')}</span>}
          </div>
          <div className="mt-3">
            <div className="mb-2 text-heavy">{t('REQUIRED_DOCUMENT.BACKEND_SERVICE.CONFIRMATION_MESSAGE')}</div>
            <div className="d-flex supplier-doc-radio-row">
              <NewRadio
                id="archive_yes"
                name="archiveOption"
                value="yes"
                checked={archiveOption === 'yes'}
                label={t('REQUIRED_DOCUMENT.BACKEND_SERVICE.YES')}
                onChange={(e) => setArchiveOption(e.target.value)}
              />
              <NewRadio
                id="archive_no"
                name="archiveOption"
                value="no"
                checked={archiveOption === 'no'}
                label={t('REQUIRED_DOCUMENT.BACKEND_SERVICE.NO')}
                onChange={(e) => setArchiveOption(e.target.value)}
              />
            </div>
          </div>
        </>
      )}
    </BombiixModal>
  );
}

const mapStateToDispatch = {
  duplicateDocumentData: duplicateDocument,
};

export default connect(null, mapStateToDispatch)(DuplicateDocument);
